import navBarHomepage from '../modules/navbar-homepage';
import videoLanding from '../modules/video-landing';
// import videoModule from '../modules/jwplayer-infinite-scroll-module';

let videoController = () => {
    navBarHomepage.on();
    videoLanding();
    // videoModule.on();
};

export default videoController;
